<template>
  <div :class="[
    'form-row',
    {
      'form-row-compact': compact,
      'form-row-flex-column': flexColumn,
      'form-row-align-center': alignCenter,
      'form-row-gap': withGap,
      'form-row-no-margin': noMargin
    }
  ]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormRow',
  props: {
    compact: {
      type: Boolean,
      default: false
    },
    flexColumn: {
      type: Boolean,
      default: false
    },
    alignCenter: {
      type: Boolean,
      default: false
    },
    withGap: {
      type: Boolean,
      default: false
    },
    noMargin: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px 16px;
  transition: all 0.2s ease;
  
  @media (max-width: 768px) {
    margin-bottom: 8px;
  }
}

.form-row-compact {
  margin-bottom: 8px;
  
  @media (max-width: 768px) {
    margin-bottom: 4px;
  }
}

.form-row-flex-column {
  flex-direction: column;
}

.form-row-align-center {
  align-items: center;
}

.form-row-gap {
  gap: 16px;
  
  @media (max-width: 768px) {
    gap: 8px;
  }
}

.form-row-no-margin {
  margin-bottom: 0;
}
</style> 